<template>
    <app-footer :show="showModal" />
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import AppFooter from './AppFooter';

export default {
    name: 'app-footer-container',
    components: {
        AppFooter,
    },
    methods: {
        ...mapActions('modal', ['show']),
        showModal() {
            this.show('userAgreement');
        },
    },
    computed: {
        
    }
}
</script>



// WEBPACK FOOTER //
// AppFooterContainer.vue?030a241e